export default () => (
  <div className="w-full pt-[35vh] flex items-center justify-center text-[70px] font-black tracking-wider text-gray-200 animate-pulse">
    GBase
  </div>
);
